const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Executa manualment un job. `tipus`:
 *   - 'propostes-setmanals'  → Generar Propostes Setmanals
 *   - 'comandes-automatiques' → Generar Comandes Automàtiques
 * Retorna {ok, message}.
 */
export const ExecutarJob = async (tipus: string, page: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/jobs/${tipus}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const message = await response.text();
        return {ok: response.ok, message};
    } catch (error) {
        console.error('Error executant el job', error);
        return {ok: false, message: 'Error executant el job'};
    }
};
